import React, { Component, Fragment, createRef } from 'react'

import { TagLocationCategoriesService } from './services';
import { HttpResponse } from '../../../../core';
import { ShowSuccessMessage, HandleNotFoundResponse } from '../../../../shared/helpers';
import { ButtonType } from '../../../../shared/enums/button.enum';
import { Link } from "react-router-dom";
import { Loader } from '../../../../shared/loaders';
import { TagLocationCategoriesTabs } from './TagLocationCategoriesTabs';
import { NotFoundResponseArea } from '../../../../shared/enums';
import { AddUpdateTagLocationCategoriesModel } from './models';

interface IState {
    editTagLocationCategories?: AddUpdateTagLocationCategoriesModel,
    id?: number;
    name?:string;    
    nameError?: string,
    isShowtext?: string;
    isSave?: string;
    isSaving?: boolean;
}
export class TagLocationCategoriesForm extends Component<any, IState> {
    private service: TagLocationCategoriesService;
    private nameRef: any;

    constructor(props) {
        super(props)
        this.service = new TagLocationCategoriesService();
        this.state = this.initialState;
        this.nameRef = createRef();
    }

    initialState: Partial<IState> = {
        editTagLocationCategories: {           
            id: 0,            
            name:""
        },        
        id: 0,        
        isShowtext: "New",
        isSave: "",
        isSaving: false,
        name:"",        
        nameError:""
    }

    componentDidMount() {
        if (this.props.match.params.id > 0) {
            this.setState({ id: this.props.match.params.id, isShowtext: "Edit" }, () => {
                this.loadData();
            });
        }
    }

    loadData() {
        this.service.editTagLocationCategories(this.props.match.params.id)
            .then((res: HttpResponse<AddUpdateTagLocationCategoriesModel>) => {
                if (res && res.result) {
                    this.setState({                       
                        id:res.result?.id,
                        name:res.result?.name                        
                    }, () => {
                        
                     });
                }
            })
            .catch(ex => {
                HandleNotFoundResponse(ex,NotFoundResponseArea.TagLocationCategory,this.props) 
            });
    }


    updateData(data: AddUpdateTagLocationCategoriesModel) {
        this.setSavingFlag(true);
        this.service.updateTagLocationCategories(data)
            .then((res: HttpResponse<AddUpdateTagLocationCategoriesModel>) => {
                this.setSavingFlag(false);
                if (res && res.result) {
                    this.setState({
                        id: res.result.id
                    }, () => {
                        ShowSuccessMessage("Tag Location Category successfully updated.");
                        if (this.state.isSave === ButtonType.Save) {
                            this.props.history.push('/tag-location-category/detail/'+ this.state.id);
                            this.setState(this.initialState);
                        }
                        if (this.state.isSave === ButtonType.SaveAndEdit) {
                            this.props.history.push('/tag-location-category/tag-location-category-form/' + this.state.id);
                            this.setState({ isShowtext: "Edit" })
                        }
                    });

                }
            }, () => {
                this.setSavingFlag(false);
            });
    }


    postData(data: AddUpdateTagLocationCategoriesModel) {
        this.setSavingFlag(true);
        this.service.postTagLocationCategories(data)
            .then((res: HttpResponse<AddUpdateTagLocationCategoriesModel>) => {
                this.setSavingFlag(false);
                if (res && res.result) {
                    this.setState({                        
                        id: res.result.id
                    }, () => {
                        ShowSuccessMessage("Tag Location Category successfully created.");
                        if (this.state.isSave === ButtonType.Save) {
                            this.props.history.push('/tag-location-category/detail/'+ this.state.id);
                            this.setState(this.initialState);
                        }
                        if (this.state.isSave === ButtonType.SaveAndAddAnother) {
                            this.setState(this.initialState);
                            this.props.history.push('/tag-location-category/tag-location-category-form/0');
                        }
                        if (this.state.isSave === ButtonType.SaveAndEdit) {
                            this.props.history.push('/tag-location-category/tag-location-category-form/' + this.state.id);
                            this.setState({ isShowtext: "Edit" })
                        }
                    });

                }
            }, () => {
                this.setSavingFlag(false);
            });;
    }


    handleChange = (event: any) => {
        const isCheckbox = event.target.type === "checkbox";
        this.setState({
            [event.target.name]: isCheckbox
                ? event.target.checked
                : event.target.value
        })
        if (this.nameRef.current.value) {
            this.setState({ nameError: "" });
          }
    }

    validate = () => {
        let nameError = "";      
        if (!this.nameRef.current.value) {
            nameError = "Name can't be blank";
        }
        if (nameError) {
            this.setState({ nameError: nameError })
            return false;
        }
        if (!nameError) {
            nameError = "";
            this.setState({ nameError: nameError})
            return true;
        }

    }

    handleSubmit = event => {
        event.preventDefault();
        const isValid = this.validate();
        let data: AddUpdateTagLocationCategoriesModel = {                        
            id: this.state.id,
            name:this.state.name            
        };
        if (isValid) {
            if (data.id == 0) {
                this.postData(data);
            }
            else
            {
        this.updateData(data);
            }
        }
    }

    handleClick = (event) => {
        this.setState({ isSave: event.target.value })
    }
    private setSavingFlag(saving: boolean) {
        this.setState({ isSaving: saving });
    }

    render() {
        return (
            <Fragment>
            <form onSubmit={this.handleSubmit}>
                <input type="hidden" value={this.state.id} />
                <div>
                <div className="d-flex justify-content-between align-items-center mb-2">
                            <h5>{this.state.isShowtext} Tag Location Category '{this.state.name}'</h5>
                        </div>
                    <div className="row">
                        <div className="col-md-12 col-xl-12">
                            <div className="card">
                                <div className="card-body">
                                {this.props.match.params.id != 0 && <TagLocationCategoriesTabs id={this.props.match.params.id} url="/tag-location-category/TagLocationCategories-form/" />}
                                    <div className="row mt-4">
                                        <div className="col-md-6">
                                            <div className="form-group shadow-sm p-3 mb-4 ">
                                                <label>Name<span className=" text-danger">*</span></label>
                                                <div className="custom-control custom-checkbox">
                                                <input type="text" maxLength={255}  ref={this.nameRef} name="name" value={this.state.name} onChange={this.handleChange} className= {!this.state.nameError ? 'form-control' : 'form-control  is-invalid'}/>
                                                <div className="invalid-feedback">
                                                        {this.state.nameError}
                                                    </div>
                                                </div>
                                            </div>                                          
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="text-center mt-3 mb-4">
                        <Link type="button" className="btn btn-lg btn-default" to="/tag-location-category/list">{ButtonType.Cancel}</Link>
                        {!this.state.isSaving && <Fragment>
                            <input type="submit" className="btn btn-lg btn-primary  ml-3" onClick={this.handleClick} value={ButtonType.Save} />      
                            <input type="submit" className="btn btn-lg btn-primary  ml-3" value={ButtonType.SaveAndAddAnother} onClick={this.handleClick} />                      
                            <input type="submit" className="btn btn-lg btn-primary  ml-3" value={ButtonType.SaveAndEdit} onClick={this.handleClick} />
                        </Fragment>
                        }
                        <Loader loading={this.state.isSaving} marginBottom="0px" marginTop="8px" width="368px" ></Loader>
                    </div>
                </div>
            </form>
        </Fragment>
        )
    }
}
